import {
    HTTP_INTERCEPTORS,
    provideHttpClient,
    withInterceptorsFromDi,
    withXsrfConfiguration,
} from '@angular/common/http';
import {ApplicationConfig, ErrorHandler, importProvidersFrom} from '@angular/core';

import {MatNativeDateModule} from '@angular/material/core';
import {MAT_ICON_DEFAULT_OPTIONS} from '@angular/material/icon';
import {MAT_TOOLTIP_DEFAULT_OPTIONS, MatTooltipDefaultOptions} from "@angular/material/tooltip";
import {BrowserModule,} from '@angular/platform-browser';
import {provideAnimations} from '@angular/platform-browser/animations';
import {RouteReuseStrategy} from '@angular/router';
import {ServiceWorkerModule} from '@angular/service-worker';
import {AdminRoutingModule} from '@app/admin/admin-routing.module';
import {AdminModule} from '@app/admin/admin.module';
import {AppRoutingModule} from '@app/app-routing.module';
import {AuthRoutingModule} from '@app/auth/auth-routing.module';
import {EmbedRoutingModule} from '@app/embed/embed-routing.module';
import {EmbedModule} from '@app/embed/embed.module';

import {FrogRouteReuseStrategy} from '@app/frog-route-reuse-strategy';
import {GetStartedModule} from '@app/getstarted/getstarted.module';
import {LandingModule} from '@app/landing/landing.module';
import {MainRoutingModule} from '@app/main/main-routing.module';
import {MainModule} from '@app/main/main.module';

import {ReviewRoutingModule} from '@app/review/review-routing.module';
import {TokenInterceptor} from '@app/token.interceptor';

import {AuthModule} from '@auth0/auth0-angular';
import * as Sentry from "@sentry/angular";
import {RECAPTCHA_V3_SITE_KEY, RecaptchaV3Module} from 'ng-recaptcha-2';
import {NgxStripeModule} from 'ngx-stripe';
import {environment} from '../environments/environment';

const tooltipDefaults: MatTooltipDefaultOptions = {
    hideDelay: 0,
    disableTooltipInteractivity: true,
    showDelay: 0,
    touchendHideDelay: 0,
    tooltipClass: 'frog-tooltip',
};

export const appConfig: ApplicationConfig = {
    providers: [
        importProvidersFrom(
            BrowserModule,
            AppRoutingModule,
            // Stripe
            NgxStripeModule.forRoot(environment.stripe_key),
            // Auth0
            AuthModule.forRoot(environment.auth0_config),
            // reCaptcha v3
            RecaptchaV3Module,
            GetStartedModule,
            LandingModule,
            MainModule,
            AdminModule,
            EmbedModule,
            MatNativeDateModule,
            // Routes
            MainRoutingModule,
            AuthRoutingModule,
            AdminRoutingModule,
            EmbedRoutingModule,
            ReviewRoutingModule,
            ServiceWorkerModule.register('ngsw-worker.js', { enabled: environment.production }),
        ),
        provideHttpClient(
            withXsrfConfiguration({
                cookieName: 'csrftoken',
                headerName: 'X-CSRFToken',
            }),
        ),
        { provide: HTTP_INTERCEPTORS, useClass: TokenInterceptor, multi: true },
        { provide: RouteReuseStrategy, useClass: FrogRouteReuseStrategy },
        { provide: RECAPTCHA_V3_SITE_KEY, useValue: environment.recaptchaSiteKey },
        { provide: MAT_ICON_DEFAULT_OPTIONS, useValue: { fontSet: 'material-symbols' } },
        {
            provide: MAT_TOOLTIP_DEFAULT_OPTIONS, useValue: tooltipDefaults
        },
        {
            provide: ErrorHandler,
            useValue: Sentry.createErrorHandler(),
        },
        provideHttpClient(withInterceptorsFromDi()),
        provideAnimations(),
    ],
};
